import { Location, NavigateFunction } from 'react-router-dom';
import scrollToPage from '../../utils/ScrollToLink';
import smallLogo from '../../assets/imgs/brda_logo_dark.svg';
import Constants from '../../utils/Constants';

const Footer = ({
  location,
  navigate,
}: {
  location: Location;
  navigate: NavigateFunction;
}) => {
  return (
    <div id={Constants.FOOTER} className='footer'>
      <div className='footer_container container'>
        <div
          className='footer_container_logo'
          onClick={() => scrollToPage('home', location, navigate)}
        >
          <img src={smallLogo} alt={Constants.PROPERTY_NAME + ' small logo'} />
        </div>
        <div className='footer_container_contacts'>
          <div className='footer_container_contacts_contact'>
            <p>
              <b>BRDA PROJEKT d.o.o.</b>
            </p>
            <p>
              <a
                href='https://maps.app.goo.gl/812f43yodjvnMxvR8'
                target='_blank'
                rel='noreferrer'
                className='opacity_transition_low'
              >
                Sarajevska 46D
              </a>
            </p>
            <p>21000 Split, Croatia</p>
            <p>
              <a href='tel:0038598323233' className='opacity_transition_low'>
                +385 98 323 233
              </a>
            </p>
            <p>
              <a
                href='mailto:prodaja@brdaprojekt.hr'
                className='opacity_transition_low'
              >
                prodaja@brdaprojekt.hr
              </a>
            </p>
          </div>
        </div>
        <div className='footer_container_bottom'>
          <p>Copyright © Brda Projekt {new Date().getFullYear()}.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
